import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/getToken";
import { unformatNumberToKobo } from "../../utils/formatNumber";

type PayloadType = {
  discountType: "Order" | "Product";
  discountName: string;
  description: string;
  startDate: string;
  endDate: string;
  percentageOff: string;
  minimumOrderAmount: string;
  maxDiscountAmount: string;
};

export const useCreateDiscountMutation = (payload: PayloadType) => {
  const navigate = useNavigate();
  const token = getToken();

  const updatedPayload = {
    ...payload,
    percentageOff: +payload?.percentageOff,
    minimumOrderAmount: unformatNumberToKobo(payload?.minimumOrderAmount),
    maxDiscountAmount: unformatNumberToKobo(payload?.maxDiscountAmount),
  };
  return useMutation({
    mutationFn: () =>
      axiosInstance
        .post("discounts", updatedPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      navigate(-1);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};

export const useCreateCustomerDiscountMutation = (payload: any) => {
  const navigate = useNavigate();
  const token = getToken();

  const updatedPayload = {
    ...payload,
    usageLimit: +payload?.usageLimit,
    flatAmountOff: unformatNumberToKobo(payload?.flatAmountOff),
  };
  return useMutation({
    mutationFn: () =>
      axiosInstance
        .post("discounts", updatedPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      navigate(-1);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
